import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootswatch/dist/darkly/bootstrap.min.css";
import '@popperjs/core';
import './rfs.css'
import App from './App';
import { Toaster } from "react-hot-toast";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider, ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { AuthContextProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        users: {
          merge(existing, incoming) {
            return incoming;
          },
        },
        posts: {
          merge(existing, incoming) {
            return incoming;
          },
        }
      },
    },
  },
})

const httpLink = createHttpLink({
  uri: 'https://social-media-app-plum-pi.vercel.app/graphql',
  credentials: ''
})

const authLink = setContext((_, { headers }) => {
  if (localStorage.getItem('token')) {
    const token = JSON.parse(localStorage.getItem('token'))
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : ''
      }
    }
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
})

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <AuthContextProvider>
        <Router>
          <App />
          <Toaster />
        </Router>
      </AuthContextProvider>
    </ApolloProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
